import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import { SelectUsers } from './SelectUsers/SelectUsers';
import { BaseField } from '../types';

export interface SelectUsersFieldDef extends BaseField {
  type: 'select-users';
}

const SelectUsersFieldForm = ({ field }: { field: SelectUsersFieldDef }) => {
  const { control, formState: { errors } } = useFormContext();
  const currentError = _.get(errors, field.key);

  return (
    <Controller
      name={field.key}
      control={control}
      render={({ field: f }) => (
        <>
          <SelectUsers label={field.label ?? ''} value={f.value ?? []} onChange={f.onChange} />
          {currentError && (
            <p className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>
              {(currentError as any).message}
            </p>
          )}
        </>
      )}
    />
  );
};

export default SelectUsersFieldForm;
